import { AxiosResponse } from 'axios';
import { useHttpClient } from '../../components/infra/httpClient.component';

export interface ContributeRequest {
    items: Array<ContributeItemRequest>,
    user: string | null | undefined
}

export interface ContributeItemRequest {
    content: string,
    name: string
}

export const useContributeService = () => {
    const httpClient = useHttpClient();

    const addImages = (request: ContributeRequest): Promise<AxiosResponse<any, any>> => {
        var formData = new FormData();
        request.items.forEach((item, index) => formData.append(`contribution_${index}`, JSON.stringify(item)));
        formData.append('user', request.user!);
        return httpClient.post(`contribute`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            maxContentLength: Infinity,
            maxBodyLength: Infinity,
            timeout: 60000
        });
    };

    return { addImages };
};